import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { Typography } from '../../../Typography/Typography';
import { TagContext } from '../../Tag.context';
import { useColor } from './hooks';
export const Label = () => {
    const { label } = useContext(TagContext);
    const color = useColor();
    return (_jsx(Typography.Text, { ellipsis: true, size: 'sm', whiteSpace: 'nowrap', pointerEvents: 'none', weight: 'medium', color: color, children: label }));
};
